import { DuplicateIcon, MinusCircleIcon } from '@heroicons/react/solid';
import { format, setDay } from 'date-fns';
import { useState } from 'react';
import { Input, Label } from '../Field';

const emptySchedule = Array(7).fill([]);

function ScheduleTab({ schedule: clinicSchedule, t, old }) {
    let oldSchedule;
    
    if (old?.schedule) {
        oldSchedule = Object.values(old.schedule);
        oldSchedule.forEach((_, index) => oldSchedule[index] = oldSchedule[index].filter(Boolean));
        oldSchedule.push(oldSchedule.shift());
    }

    const [schedule, setSchedule] = useState(oldSchedule || clinicSchedule || emptySchedule);

    const changeHandler = (weekday, index, field, value) => {
        setSchedule((oldValue) => {
            const newValue = JSON.parse(JSON.stringify(oldValue));
            newValue[weekday][index][field] = value;
            return newValue;
        });
    };

    const removeHandler = (weekday, index) => {
        setSchedule((oldValue) => {
            const newValue = JSON.parse(JSON.stringify(oldValue));
            newValue[weekday].splice(index, 1);
            return newValue;
        });
    };

    const addHandler = (weekday) => {
        setSchedule((oldValue) => {
            const newValue = JSON.parse(JSON.stringify(oldValue));
            newValue[weekday].push({
                weekday: weekday,
                start: '',
                end: '',
            });
            return newValue;
        });
    };

    const replicateMonday = () => {
        setSchedule((oldValue) => {
            const newValue = JSON.parse(JSON.stringify(oldValue));
            for (let i = 1; i <= 6; i++) {
                newValue[i] = JSON.parse(JSON.stringify(newValue[0]));
            }
            return newValue;
        });
    };

    return (
        <table>
            <tbody>
                {schedule.map((hours, weekdayIndex) => {
                    const weekday = (weekdayIndex + 1) % 7;
                    return (
                        <tr key={weekday}>
                            <td className="flex items-center gap-2 pr-8 align-top capitalize">
                                <Label>{format(setDay(new Date(), weekday), 'iiii', { locale: window.dateLocale })}</Label>
                                {weekday == 1 && (
                                    <button type="button" title={t('clone-schedule')} onClick={replicateMonday}>
                                        <DuplicateIcon className="h-4 text-gray-400 hover:text-gray-600" />
                                    </button>
                                )}
                            </td>
                            <td className="pb-4">
                                <div className="space-y-1">
                                    {hours.length == 0 && <input type="hidden" name={`schedule[${weekday}][]`} />}
                                    {hours.map((entry, index) => (
                                        <div key={index} className="flex items-center gap-1">
                                            <input type="hidden" name={`schedule[${weekday}][${index}][weekday]`} defaultValue={weekday} />
                                            <Input
                                                type="time"
                                                className="py-1 text-xs"
                                                name={`schedule[${weekday}][${index}][start]`}
                                                value={entry.start}
                                                onChange={(e) => {
                                                    changeHandler(weekdayIndex, index, 'start', e.target.value);
                                                }}
                                                required
                                            />
                                            <Input
                                                type="time"
                                                className="py-1 text-xs"
                                                name={`schedule[${weekday}][${index}][end]`}
                                                value={entry.end}
                                                onChange={(e) => {
                                                    changeHandler(weekdayIndex, index, 'end', e.target.value);
                                                }}
                                                required
                                            />
                                            <button
                                                onClick={() => {
                                                    removeHandler(weekdayIndex, index);
                                                }}
                                                type="button"
                                                className="ml-2 flex-none text-gray-400 hover:text-gray-700"
                                            >
                                                <MinusCircleIcon className="h-5 w-5" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <button
                                    onClick={() => {
                                        addHandler(weekdayIndex);
                                    }}
                                    type="button"
                                    className="text-xs text-gray-500 hover:text-gray-800"
                                >
                                    + {t('add-schedule')}
                                </button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}

export default ScheduleTab;
